/**
 * Builds a reference string for width measurement by taking the longer of
 * value/total and replacing all digits with "0" (the widest digit in most fonts).
 */
export function getMeasureReferenceText(value: string, total: string): string {
  return (value.length >= total.length ? value : total).replace(/[0-9]/g, '0');
}

/**
 * Computes an input width from a measured pixel width plus horizontal padding on both sides.
 * Returns undefined before the first measurement completes.
 */
export function getInputWidthFromMeasure(measureWidth: number, paddingH: string): string | undefined {
  return measureWidth > 0 ? `calc(${measureWidth}px + ${paddingH} * 2)` : undefined;
}